import { render, staticRenderFns } from "./project-task.vue?vue&type=template&id=0d334f06&"
import script from "./project-task.vue?vue&type=script&lang=js&"
export * from "./project-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports